<template>
    <div>
        <MedicineTable />
    </div>
</template>

<script>
import MedicineTable from '@/components/medicine/MedicineTable.vue'

export default {
    components: {
        MedicineTable
    },
    name: 'Medicines'
}
</script>